import { Button, CheckBox, Form, NumberBox, Popup, RadioGroup, TextBox } from 'devextreme-react';
import { DropDownButton, Item as DdbItem } from 'devextreme-react/drop-down-button';
import { ButtonItem, ButtonOptions, Label, SimpleItem } from 'devextreme-react/form';
import { SelectBox, Item as SbItem } from 'devextreme-react/select-box';
import { Component } from 'react';
import Inline from '../Inline';
import { TagBox, Item as TagItem } from 'devextreme-react/tag-box';
import { apiGetP, apiPostP } from '../../GanjiTools';
import WtLogon from '../wt/WtLogon';
import './LoginBuilder.css';

class LoginBuilder extends Component {
    state = {
        logonPage: {
            name: 'default',
            passwordChangeMethod: 'can_reset',
        },
        viewMode: 'design',
    }

    setViewMode = viewMode => {
        if (viewMode === 'preview' && !(this.state.name?.length > 0))
            this.setState({ viewMode, saveLogonPagePopVisible: true });
        else
            this.setState({ viewMode });
    }

    onLoadLogonPagesList = thenUpdate => {
        apiGetP('/api/logon/logonPageNames')
            .catch(window.notif)
            .then(res => {
                let { error, list } = res ?? { error: 'No result.' };
                if (error?.length > 0) {
                    window.notif(error);
                    return;
                }
                this.state.names = list;
                this.state.namesKey++;

                if (thenUpdate !== false)
                    this.forceUpdate();
            });
    }

    onLoadLogonPage(name) {
        apiGetP(`/api/logon/loadLogonPage?name=${name}`)
            .catch(window.notif)
            .then(res => {
                res ??= { error: 'No response' };

                if (res.error?.length > 0) {
                    window.notif(res.error);
                    return;
                }

                let { name, logonPage } = res;

                this.setState({ name, logonPage });
            });
    }

    onSaveLogonPage = () => {
        apiPostP('/api/logon/saveLogonPage', this.state.logonPage)
            .catch(window.notif)
            .then(res => {
                let { error } = res ?? { error: 'No result.' };
                if (error?.length > 0) {
                    window.notif(error);
                    return;
                }
                window.notif('با موفقیت ذخیره شد');
            });
    }

    onBuildNewLogonPage = thenForceUpdate => {
        this.state.logonPage = {};
        this.state.name = '';
        this.state.viewMode = 'design';

        if (thenForceUpdate)
            this.forceUpdate();
    }

    componentDidMount() {
        this.onLoadLogonPagesList();
    }

    render() {
        return (
            <>
                <div style={{ margin: '2rem' }}>
                    {this.state.viewMode === 'preview'
                        ?
                        <WtLogon name={this.state.name ?? this.state.logonPage.name} />
                        :
                        <Form colCount={60} width='60rem' rtlEnabled className='auto-margin'
                        >
                            <SimpleItem colSpan={30}>
                                <Label text='عنوان' />
                                <TextBox value={this.state.logonPage.name}
                                    onValueChanged={e => this.setState({ name: e.value, logonPage: { ...this.state.logonPage, name: e.value } })}
                                />
                            </SimpleItem>

                            <SimpleItem colSpan={30}>
                                <Label text='فوتر' />
                                <TextBox value={this.state.logonPage.footer}
                                    onValueChanged={e => this.setState({ logonPage: { ...this.state.logonPage, footer: e.value } })}
                                />
                            </SimpleItem>

                            <SimpleItem colSpan={30}>
                                <Label text='رجکس رمز' />
                                <TextBox value={this.state.logonPage.passwordRegex}
                                    onValueChanged={e => this.setState({ logonPage: { ...this.state.logonPage, passwordRegex: e.value } })}
                                />
                            </SimpleItem>
                            <SimpleItem colSpan={30}>
                                <Label text='تعداد دفعات بدون کپچا' />
                                <NumberBox value={this.state.logonPage.noCaptchaTries}
                                    onValueChanged={e => this.setState({ logonPage: { ...this.state.logonPage, noCaptchaTries: e.value } })}
                                />
                            </SimpleItem>

                            <SimpleItem colSpan={30}>
                                <Label text='تغییر رمز' />
                                <SelectBox displayExpr='text' valueExpr='value' rtlEnabled
                                    value={this.state.logonPage.passwordChangeMethod}
                                    onValueChanged={e => this.setState({ logonPage: { ...this.state.logonPage, passwordChangeMethod: e.value } })}
                                >
                                    <SbItem value='no_change' text='غیر قابل تغییر' />
                                    <SbItem value='can_reset' text='فقط قابل بازنشانی' />
                                    <SbItem value='can_change' text='قابل تغییر به رمز دلخواه' />
                                </SelectBox>
                            </SimpleItem>

                            <SimpleItem colSpan={30} visible={this.state.logonPage.passwordChangeMethod === 'can_reset'}>
                                <Label text='ارسال رمز از طریق' />
                                <TagBox displayExpr='text' valueExpr='value'
                                    value={(this.state.logonPage.sendPasswordVia ?? '')?.split('/')?.filter(x => x?.length > 0)}
                                    onValueChanged={e => {
                                        let s = (e.value ?? []).reduce((a, b) => `${a}/${b}`, '');
                                        this.state.logonPage.sendPasswordVia = `/${s}/`;
                                        //this.setState({ logonPage: { ...this.state.logonPage, sendPasswordVia: `/${s}/` } })
                                    }}
                                >
                                    <TagItem value='email' text='email' />
                                    <TagItem value='SMS' text='SMS' />
                                </TagBox>
                            </SimpleItem>

                            <SimpleItem colSpan={30}>
                                <Inline style={{ height: '34px' }}>
                                    <label style={{ width: '10rem' }}>تصویر پس زمینه:</label>
                                    <div style={{
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        width: '100%', height: '34px',
                                        marginLeft: '10px', color: 'lightgray', cursor: 'pointer',
                                        border: '1px dashed gray'
                                    }}>
                                        انتخاب تصویر...</div>
                                </Inline>
                            </SimpleItem>
                            <SimpleItem colSpan={30}>
                                <Label text='جعبه اطلاعیه ها و اخبار' />
                                <CheckBox value={this.state.logonPage.newsBox === true}
                                    onValueChanged={e => this.setState({ logonPage: { ...this.state.logonPage, newsBox: e.value } })}
                                />
                            </SimpleItem>
                        </Form>
                    }

                    <Inline spacing='1rem' style={{ marginTop: '50vh', width: '100%', justifyContent: 'center', position: 'fixed', bottom: '50px' }}
                    >
                        <DropDownButton key={'btnViewMode_' + this.state.viewMode}
                            rtlEnabled width='15rem'
                            text={this.state.viewMode === 'preview' ? 'پیش نمایش' : 'طراحی'}
                            showArrowIcon icon={this.state.viewMode === 'preview' ? 'photo' : 'edit'}
                            selectedItemKey={this.state.viewMode}
                        >
                            <DdbItem text='طراحی' icon='edit' key='design' onClick={() => this.setViewMode('design')} />
                            <DdbItem text='پیش نمایش' icon='photo' key='preview' onClick={() => this.setViewMode('preview')} />
                        </DropDownButton>

                        <Button text='ساخت لاگین جدید' icon='file' width='15rem' type='success' rtlEnabled
                            onClick={this.onBuildNewLogonPage} //stylingMode='outlined'
                        />
                        <Button text='بارگذاری' icon='folder' width='15rem' type='success' rtlEnabled
                            onClick={() => this.setState({ loadLogonPagePopVisible: true })}
                        />
                        <Button text='ذخیره' icon='save' width='15rem' type='success' rtlEnabled
                            onClick={() => this.onSaveLogonPage()}
                        //onClick={() => this.setState({ saveLogonPagePopVisible: true })}
                        />
                    </Inline>
                </div>
                {/* 
                <Popup rtlEnabled title='ذخیره لاگین' visible={this.state.saveLogonPagePopVisible} key={'saveLogonPop_' + this.state.name}
                    onHiding={() => this.setState({ saveLogonPagePopVisible: false })}
                    width='20vw' height='auto'
                >
                    <Form colCount={60}>
                        <SimpleItem colSpan={60}>
                            <Label text='عنوان' />
                            <TextBox value={this.state.name}
                                onValueChanged={e => this.setState({ name: e.value })}
                            />
                        </SimpleItem>
                    </Form>
                    <br />
                    <Inline spacing='1rem'>
                        <Button text='ثبت' icon='save' width='10rem' type='success'
                            onClick={() => this.setState({ saveLogonPagePopVisible: false }, () => this.onSaveLogonPage())}
                        />
                        <Button text='انصراف' icon='close' type='danger' width='10rem'
                            onClick={() => this.setState({ saveLogonPagePopVisible: false })}
                        />
                    </Inline>
                </Popup> 
                */}

                <Popup rtlEnabled title='بازیابی لاگین' visible={this.state.loadLogonPagePopVisible}
                    onHiding={() => this.setState({ loadLogonPagePopVisible: false })}
                    width='20vw' height='auto' key={'loadPop' + this.state.namesKey}
                >
                    <Form colCount={60} key={'loadForm' + this.state.namesKey}>
                        <SimpleItem colSpan={50}>
                            <Label text='عنوان' />
                            <SelectBox items={this.state.names} value={this.state.name}
                                onValueChanged={e => this.setState({ name: e.value })}
                            />
                        </SimpleItem>
                        <ButtonItem colSpan={10}>
                            <ButtonOptions icon='refresh' onClick={() => this.onLoadLogonPagesList()} />
                        </ButtonItem>
                    </Form>
                    <br />
                    <Inline spacing='1rem'>
                        <Button text='خواندن' icon='save' width='10rem' type='success'
                            onClick={() => this.setState({ loadLogonPagePopVisible: false }, () => this.onLoadLogonPage(this.state.name))}
                        />
                        <Button text='انصراف' icon='close' type='danger' width='10rem'
                            onClick={() => this.setState({ loadLogonPagePopVisible: false })}
                        />
                    </Inline>
                </Popup>
            </>
        );
    }
}

export default LoginBuilder;